import { atom } from 'jotai';

// Open/Close state
export const misconfiguredOverlayOpenAtom = atom(false);
misconfiguredOverlayOpenAtom.debugLabel = 'misconfiguredOverlayOpenAtom';

// Toggle to enable/disable misconfigured borders (off by default)
export const showMisconfiguredBordersAtom = atom(false);
showMisconfiguredBordersAtom.debugLabel = 'showMisconfiguredBordersAtom';
